import React, { Component } from "react";
import { graphql, QueryRenderer } from "react-relay";
import Markdown from "react-markdown";
import { ContainerWrapper } from "./Utils";

import environment from "../Environment";

const query = graphql`
    query Display_Query($id: ID!) {
        node (id: $id) {
            name
            id
            content
        }
    }
`;

export default class Display extends Component {
  constructor(props) {
    super(props);
  }

  render() {

    return (
      <div className="App">
        <QueryRenderer
          query={query}
          environment={environment}
          variables={{ id: this.props.id }}
          render={({ error, props }) => {
            if (error) {
              return <div>Error</div>;
            }

            if (props && !props.node) {
              return <div>Cannot find an element by this id</div>;
            }

            if (!props) {
              return <div>Loading...</div>;
            }

            console.log(props.node.content);

            return <ContainerWrapper textAlign="justify">
             <Markdown source={props.node.content} />
            </ContainerWrapper>;
          }}
        />

      </div>);
  }
}




// WEBPACK FOOTER //
// ./src/Components/Display.js